import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Integrations } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
import axios from 'axios'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0
    })
}

Vue.use(Vuelidate)
Vue.use(VueI18n)

Vue.prototype.$log = console.log

// fonts
require('typeface-rubik')
require('typeface-source-sans-pro')

// library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// polyfill for PDF-Blob
require('blobjs')

// set api endpoint as axios' base url
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// use axios interceptor to append authenticated requests, when possible
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.common['Authorization'] = 'Bearer ' + token
    }
    return config
})

// redirect to login, when api returns 401
axios.interceptors.response.use(
    ok => ok,
    err => {
        if (err.response.status === 401) {
            store.dispatch('authentication/logout')
        }

        throw err
    }
)

// load translation messages
const i18n = new VueI18n({
    locale: 'de',
    messages: {
        de: {} // loaded in components
    }
})

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
